import { useEffect, useState } from "react";
import { auth } from "../auth";
export const useIsAuthenticated = () => {
    const [hookState, setHookState] = useState({
        loading: true,
        authenticated: false,
    });
    useEffect(() => {
        (async () => {
            const result = await auth.isAuthenticated;
            setHookState({ loading: false, authenticated: result !== false });
        })();
    }, []);
    return [hookState.loading, hookState.authenticated];
};
